export default [
  {
    path: '/trainingsession',
    component: () => import('src/layouts/DefaultLayout'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'TrainingsessionSessionList',
        component: () => import('./containers/SessionListContainer'),
        children: [
          {
            path: 'create',
            name: 'TrainingsessionCreateSession',
            component: () => import('./containers/SessionCreateContainer'),
          },
        ],
      },
    ],
  },
]
